import ApiURLs from "@/ApiURLs";
import HttpService from "../HttpService";
import { MethodType } from "@/models/http/MethodType";
import CollectUserEventStatisticsDto from "@/models/users/event-statistics/collectUserEventStatisticsDto";
import UserEventStatsDto from "@/models/users/event-statistics/userEventStatsDto";
import { UrlBuilder } from "@/builders/UrlBuilder";
import Collection from "@/models/collection";
import UserSubscription from "@/models/users/subscriptions/userSubscription";

export class UserService {
   public static async collectStatistics(collectUserEventStatisticsDto: CollectUserEventStatisticsDto) : Promise<UserEventStatsDto> {
      const url = ApiURLs.users.eventStatistics.actions.collect;

      const response = await HttpService.send<UserEventStatsDto>(url, MethodType.POST, collectUserEventStatisticsDto);

      return response.data;
   }

   public static async getUserSubscriptions(userEmail: string) : Promise<Collection<UserSubscription>> {
      const url = UrlBuilder.build(ApiURLs.users.subscriptions.get, { email: userEmail });

      const response = await HttpService.send<Collection<UserSubscription>>(url, MethodType.GET);

      return response.data;
   }
}